import React, { FC } from 'react';
import { RELATED_ENTITY_TYPE, RelatedEntityNameLink } from '../merchants/RelatedEntityNameLink';

interface Props {
	error: string[];
}

export const ProviderActiveModal: FC<Props> = ({ error }) => {

	return (
		<>
			<div className="px-8 fs-6 mt-10 pb-5">
				<div>
					Deactivating this Payment Service Provider (PSP) will remove it from your merchant`s Payment Gateways/Processors section. However, any orders or transactions currently in process will not be affected and you can still perform refunds as needed.
				</div>
				{
					error?.length > 0 &&
					(
						<>
							<div className="text-danger fs-6 mt-2">This provider still has active merchants ({error.length}):</div>
							<div className="provider-error-container">
								{error.map((mid, index) => (
									<div key={mid} className="mt-2 d-flex align-items-center">
										<span className="text-danger fw-bolder me-1">{index + 1}. </span>
										<RelatedEntityNameLink id={mid} type={RELATED_ENTITY_TYPE.MERCHANT} />
									</div>
								))}
							</div>
						</>
					)
				}
			</div>
		</>
	);
};
